export default __webpack_public_path__ + "static/enhancing-operational-efficiency-with-digital-activity-scheduler-bc99cac56f2462a4f85b530ef69dec1e.png";